import React from "react";

const InfoContext = React.createContext();

export default InfoContext;